<script lang="ts" setup>
  import type { Song } from '../../../../shared/api/song.ts';

  defineProps<{ song: Song }>();
</script>

<template>
  <div class="song-details">
    <p class="title">{{ song.title }}</p>
    <p class="artists">{{ song.artists.join(', ') }}</p>
    <p class="year">{{ song.year }}</p>
  </div>
</template>

<style scoped>
  .song-details {
    display: flex;
    flex-direction: column;
    gap: var(--song-details-gap, 0.25rem);
    overflow: hidden;
  }

  .title {
    font-size: var(--font-size-md);
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .artists {
    color: var(--color-text-muted);
    font-size: var(--font-size-sm);
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .year {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    margin: 0;
  }
</style>
